/**
 * Routes where the user is not authenticated; skip layout chrome and API calls.
 */
export const PUBLIC_AUTH_PATHS = [
  "/sign-in",
  "/sign-up",
  "/forgot_password",
  "/reset-password",
];

export function isPublicAuthPath(path) {
  if (!path || typeof path !== "string") return false;
  return PUBLIC_AUTH_PATHS.includes(path);
}
